<script setup lang="ts">
import { cpf } from '@solfacil/frontend-utils'
import { useCpfValidation } from '~/composables/simulation/useCpfValidation'
import { useIncludeGuarantor } from '~/composables/simulation/useIncludeGuarantor'

const props = defineProps<{
  refetchProject: () => void
  setFalseLoadingGuarantor: () => void
}>()
const emit = defineEmits<{
  (event: 'update:is-loading', value: boolean): void
}>()
const { t } = useI18n()
const { value: cpfModel, errorMessage, setErrors, resetField, validate } = useCpfValidation(t)
const { includeGuarantor, isPending } = useIncludeGuarantor(props.refetchProject, props.setFalseLoadingGuarantor, emit)
</script>

<template>
  <div class="flex gap-4 w-full">
    <SolInputText
      id="include-guarantor"
      v-model="cpfModel"
      name="cpfGuarantor"
      class="w-full"
      :mask="cpf.mask"
      :placeholder="t('form.guarantor.placeholder')"
      :disabled="isPending"
      autocomplete="off"
      :error="errorMessage"
    />
    <SolButton
      id="customer_confirm"
      class="flex-1 box-border !py-4 !px-6 flex !h-[48px] whitespace-nowrap"
      :loading="isPending"
      size="large"
      on-color
      :disabled="isPending"
      @click="includeGuarantor(cpfModel, resetField, setErrors, validate)"
    >
      <div class="flex items-center gap-2">
        <span class="fonts-body-medium-bold">{{ t('form.guarantor.button') }}</span>
      </div>
    </SolButton>
  </div>
</template>
